module.exports = __webpack_public_path__ + "img/dayinji.1c5fb29c.png";